import BookLibraryAdapter from 'teacher-ui-client/adapters/book-library'

export default class BookLibraryBookAdapter extends BookLibraryAdapter {}
